/**
 * @generated SignedSource<<025dedfc045d18e17550bc97d98e1d48>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EmployeeSelectControllerListItem_employee$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"Avatar_employee">;
  readonly " $fragmentType": "EmployeeSelectControllerListItem_employee";
};
export type EmployeeSelectControllerListItem_employee$key = {
  readonly " $data"?: EmployeeSelectControllerListItem_employee$data;
  readonly " $fragmentSpreads": FragmentRefs<"EmployeeSelectControllerListItem_employee">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployeeSelectControllerListItem_employee",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Avatar_employee"
    }
  ],
  "type": "Employee",
  "abstractKey": null
};

(node as any).hash = "f1714ba74a91ab6fed282e41e9f15a61";

export default node;
